import {globalSettings} from "../globalSettings";
import type {NotificationSettings} from "../../src/components/notification-settings/notification-settings";

import {html} from "lit";
import type {Meta, StoryObj} from "@storybook/web-components";

const meta: Meta<NotificationSettings> = {
	title: "Notification/Notification Settings",
	component: "uxn-notification-settings",

	render: ({locale, stage, debug}) => html` <uxn-notification-settings locale="${locale}" stage="${stage}" debug="${debug}" /> `,

	argTypes: {
		locale: {control: "text"},
		stage: {control: "select", options: ["PROD", "QA", "INT"]},
		debug: {control: "boolean"},
	},
};

export default meta;
type Story = StoryObj<NotificationSettings>;

export const Default: Story = {
	args: {
		locale: globalSettings.locale,
		stage: globalSettings.stage,
		debug: globalSettings.debug,
	},
};
